<template>
  <div class="page mine-page">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- Header with profile -->
      <div class="profile-header">
        <van-nav-bar class="nav-bar" :title="$t('my.personal_center')">
          <template #right>
            <van-icon name="chat-o" @click="$router.push({path:'/ServiceOnline'});" color="#fff" />
          </template>
        </van-nav-bar>
        <div class="profile-info" @click="doLogin()">
          <van-image round class="avatar" src="/img/mine/head_logo.png">
            <template v-slot:loading>
              <van-loading type="spinner" />
            </template>
          </van-image>
          <div class="profile-detail">
            <p class="username">{{this.userInfo.username || $t("setting.log_reg")}}</p>
            <div class="badge-row">
              <span v-if="this.userInfo.vipname" class="vip-badge">
                <van-icon name="gem" />{{this.userInfo.vipname}}
              </span>
              <span v-else class="vip-badge">
                <van-icon name="gem" />vip0
              </span>
              <span v-if="this.userInfo.reputation !== null" class="vip-badge">
                {{$t("my.reputation")}}：{{this.userInfo.reputation}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="content-wrap">
        <!-- Finance actions -->
        <div class="finance-bar">
          <div class="finance-item" @click="doRecharge()">
            <van-icon class="finance-icon recharge-icon" name="balance-pay" />
            <span class="finance-text">充值积分</span>
          </div>
          <div class="finance-item" @click="doWithdrawal()">
            <van-icon class="finance-icon" name="exchange" />
            <span class="finance-text">提现积分</span>
          </div>
        </div>

        <!-- Wallet card -->
        <div class="wallet-card">
          <div class="wallet-header">
            <span class="wallet-label">{{$t("my.activity_points")}}</span>
          </div>
          <div class="wallet-body">
            <div class="balance-row">
              <span class="balance-value">{{ this.userInfo.money || '0' }}</span>
              <div class="refresh-btn" @click="refresh()">
                <van-icon name="replay" />
              </div>
            </div>
            <div class="balance-sub">
              {{$t("my.frozen_money")}}({{this.userInfo.frozen_money || '0'}})
            </div>
          </div>
        </div>

        <!-- Menu grid -->
        <div :style="{ marginTop: menu_top +'px'}" class="menu-grid">
          <div class="menu-item" @click="$router.push({path:'/SystemMessages'});">
            <span class="pretty-menu-icon message-menu-icon">
              <van-icon name="envelop-o" />
              <i v-if="unreadMessages > 0" class="unread-badge">{{ unreadMessages > 99 ? '99+' : unreadMessages }}</i>
            </span>
            <span class="menu-label">系统消息</span>
          </div>
          <div class="menu-item" @click="$router.push({path:'/Setbank'});">
            <van-image class="menu-icon" src="/img/mine/nav1.png">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="menu-label">{{$t("my.bank_information")}}</span>
          </div>
          <div class="menu-item" @click="toService()">
            <van-image class="menu-icon" src="/img/emptyData.png">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="menu-label">{{$t("withdraw.with_record")}}</span>
          </div>
          <div class="menu-item" @click="$router.push({path:'/GameRecord'});">
            <van-image class="menu-icon" src="/img/mine/baobiao.png">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="menu-label">{{$t("my.task_log")}}</span>
          </div>
          <div class="menu-item" @click="$router.push({path:'/SetLoginPassword'});">
            <van-image class="menu-icon" src="/img/mine/nav7.png">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="menu-label">{{$t("my.Login_password")}}</span>
          </div>
          <div class="menu-item" @click="$router.push({path:'/setPayPassword'});">
            <van-image class="menu-icon" src="/img/mine/5.png">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="menu-label">{{$t("my.withdraw_password")}}</span>
          </div>
        </div>

        <!-- Logout -->
        <div class="logout-area">
          <button class="btn-gradient logout-btn" @click="loginout()">
            {{$t("setting.logout")}}
          </button>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userInfo: {},
        menu_top: 30,
        isLoading: false,
        unreadMessages: 0,
      };
    },
    methods: {
      getSystemMessageUnread() {
        this.$http({ method: 'get', url: 'user_system_message_unread' }).then(res => {
          if (res && res.code === 200) this.unreadMessages = Number(res.data.unread || 0);
        });
      },
      doRecharge() {
        this.$dialog.confirm({
          className: 'recharge-contact-dialog',
          title: '系统提示',
          message: '请联系在线客服办理',
          confirmButtonText: '在线客服',
          cancelButtonText: '取消',
          closeOnClickOverlay: true,
        }).then(() => {
          this.$router.push({ path: '/ServicePage' });
        }).catch(() => {});
      },
      refresh() {
        this.isLoading = true;
        setTimeout(() => {
          this.isLoading = false;
          if (localStorage.getItem('token')) {
            this.$toast(this.$t("reservation.refresh"));
          } else {
            this.$router.push({ path: '/Login' })
          }
        }, 500);
      },
      toService() {
        console.log(this.$store.getters.getBaseInfo)
        if (this.$store.getters.getBaseInfo.iskefu == 1) {
          this.$router.push("WithdrawRecord");
        } else {
          this.$toast.fail(this.$t("setting.forbid"));
        }
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false;
          if (localStorage.getItem('token')) {
            this.getUserInfo();
            this.$toast(this.$t("reservation.refresh"));
          } else {
            this.$router.push({ path: '/Login' })
          }
        }, 500);
      },
      doLogin() {
        if (localStorage.getItem('token')) {
          this.$router.push({ path: '/Infomation' });
        } else {
          this.$router.push({ path: '/Login' })
        }
      },
      doWithdrawal() {
        this.$http({
          method: 'get',
          url: 'user_get_bank'
        }).then(res => {
          if (res.data.is_bank) {
            this.$router.push("withdraw");
          } else {
            this.$router.push("Setbank");
            this.$toast.fail(this.$t("setting.set_bank"));
          }
        })
      },
      getUserInfo() {
        this.$http({
          method: 'get',
          url: 'user_info'
        }).then(res => {
          if (res.code === 200) {
            this.userInfo = res.data;
            this.menu_top = 15;
            if(this.userInfo.is_online == 0){
              this.$toast(this.$t("video.account_out"));
              this.deleteCookie('selid');
              localStorage.clear()
              this.$router.push({ path: '/Login' })
            }
            if (this.userInfo.status !== 1) {
              this.$toast(this.$t("video.account_out"));
              localStorage.clear()
              this.$router.push({ path: '/Login' })
            }
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
      },
      loginout() {
        this.$http({
          method: 'get',
          url: 'user_out'
        }).then(res => {
          if (res.code === 200) {
            this.$toast(res.msg);
            this.deleteCookie('selid');
            this.deleteCookie('think_var');
            this.$router.push({ path: '/Login' });
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
      },
      setCookie(name, value, days) {
        let expires = '';
        if (days) {
          const date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
      },
      deleteCookie(name) {
        this.setCookie(name, "", -1);
      }
    },
    created() {
      if (localStorage.getItem('token')) {
        this.getUserInfo();
        this.getSystemMessageUnread();
      } else {
        this.userInfo.username = this.$t("setting.log_reg");
        this.userInfo.ip = this.$t("setting.more_service");
        this.userInfo.header_img = "img/mine/avatar.png";
      }
    },
    activated() {
      if (localStorage.getItem('token')) this.getSystemMessageUnread();
    }
  };
</script>

<style scoped>
.mine-page {
  background: #f6f5f2;
  padding-bottom: 120px;
}

/* Profile header */
.profile-header {
  background: linear-gradient(135deg, #7c6ff0, #db6ea9);
  border-radius: 0 0 var(--radius-xl) var(--radius-xl);
  padding-bottom: 60px;
  position: relative;
}

.profile-header::after {
  content: '';
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  height: 40px;
  background: #f6f5f2;
  border-radius: var(--radius-xl) var(--radius-xl) 0 0;
}

.nav-bar {
  background: transparent !important;
}

.profile-info {
  display: flex;
  align-items: center;
  padding: 0 28px;
  gap: 20px;
  position: relative;
  z-index: 1;
}

.avatar {
  width: 100px;
  height: 100px;
  border: 3px solid rgba(255,255,255,.3);
}

.profile-detail {
  flex: 1;
}

.username {
  font-size: 32px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.badge-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.vip-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  line-height: 30px;
  border-radius: 999px;
  padding: 2px 12px;
  font-weight: 700;
  font-size: 28px;
  background: linear-gradient(to right, #ff6b6b, #ffa94d);
  color: #fff;
  box-shadow: 0 4px 12px rgba(0,0,0,.15);
}

/* Content area */
.content-wrap {
  position: relative;
  z-index: 1;
  padding: 0 16px;
  margin-top: -8px;
}

/* Finance bar */
.finance-bar {
  display: flex;
  background: rgba(255,255,255,.78);
  border: 1px solid rgba(255,255,255,.72);
  box-shadow: var(--shadow-soft);
  border-radius: var(--radius-lg);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  padding: 20px 16px;
  margin-bottom: 16px;
}

.finance-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  gap: 14px;
  cursor: pointer;
}

.finance-item + .finance-item {
  border-left: 1px solid rgba(124,111,240,.14);
}

.finance-icon {
  font-size: 46px;
  color: var(--primary);
}

.recharge-icon {
  color: #db6ea9;
}

.finance-text {
  font-size: 29px;
  color: var(--text);
  font-weight: 500;
}

/* Wallet card */
.wallet-card {
  background: linear-gradient(135deg, #7c6ff0, #6bb6ff);
  border-radius: var(--radius-lg);
  padding: 20px 24px;
  margin-bottom: 16px;
  box-shadow: 0 12px 32px rgba(124,111,240,.2);
}

.wallet-header {
  margin-bottom: 12px;
}

.wallet-label {
  color: rgba(255,255,255,.8);
  font-size: 26px;
}

.balance-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.balance-value {
  flex: 1;
  font-size: 48px;
  font-weight: 700;
  color: #fff;
}

.refresh-btn {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255,255,255,.2);
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}

.balance-sub {
  margin-top: 8px;
  color: rgba(255,255,255,.7);
  font-size: 22px;
}

/* Menu grid */
.menu-grid {
  display: flex;
  flex-wrap: wrap;
  background: rgba(255,255,255,.78);
  border: 1px solid rgba(255,255,255,.72);
  box-shadow: var(--shadow-soft);
  border-radius: var(--radius-lg);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  padding: 8px 0;
}

.menu-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33.33%;
  padding: 20px 0;
  cursor: pointer;
  transition: transform .18s ease;

  &:active {
    transform: scale(.95);
  }
}

.menu-icon {
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
  object-fit: contain;
}

.menu-label {
  font-size: 22px;
  color: var(--text);
  font-weight: 500;
}

/* Logout */
.logout-area {
  padding: 32px 0 80px;
}

.logout-btn {
  width: 100%;
  height: 88px;
  font-size: 28px;
  background: linear-gradient(135deg, #db6ea9, #f6a85b) !important;
}
</style>

<style>
.recharge-contact-dialog.van-dialog {
  width: 84%;
  max-width: 620px;
  overflow: hidden;
  border: 0;
  border-radius: 32px;
  background: linear-gradient(155deg, #ffffff 0%, #faf8ff 100%);
  box-shadow: 0 24px 70px rgba(69, 55, 128, 0.25);
}

.pretty-menu-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  margin-bottom: 8px;
  border-radius: 17px;
  color: #fff;
  box-shadow: 0 7px 16px rgba(92, 74, 174, .22);
}
.pretty-menu-icon .van-icon { font-size: 30px; }
.message-menu-icon { background: linear-gradient(135deg, #7868ee 0%, #d96fae 100%); }
.language-menu-icon { background: linear-gradient(135deg, #38b8cf 0%, #6c78e9 100%); }
.unread-badge {
  position: absolute;
  top: -9px;
  right: -14px;
  min-width: 28px;
  height: 28px;
  padding: 0 7px;
  border: 3px solid #fff;
  border-radius: 18px;
  background: #ff405b;
  color: #fff;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  text-align: center;
  box-shadow: 0 4px 10px rgba(255,64,91,.35);
}

.recharge-contact-dialog .van-dialog__header {
  padding: 106px 30px 14px;
  color: #2e2942;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.3;
  position: relative;
}

.recharge-contact-dialog .van-dialog__header::before {
  content: "¥";
  position: absolute;
  top: 28px;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  transform: translateX(-50%);
  border: 0;
  border-radius: 20px;
  color: #fff;
  font-size: 34px;
  font-weight: 700;
  background: linear-gradient(135deg, #7c6ff0, #db6ea9);
  box-shadow: 0 10px 26px rgba(124, 111, 240, 0.3);
}

.recharge-contact-dialog .van-dialog__message {
  padding: 14px 36px 42px;
  color: #777187;
  font-size: 27px;
  line-height: 1.6;
}

.recharge-contact-dialog .van-dialog__footer {
  gap: 18px;
  padding: 0 32px 32px;
  background: transparent;
}

.recharge-contact-dialog .van-dialog__button {
  height: 76px;
  border: 0;
  border-radius: 40px;
  font-size: 27px;
  font-weight: 600;
}

.recharge-contact-dialog .van-dialog__cancel {
  color: #777187;
  border: 0;
  background: #f0eef5;
}

.recharge-contact-dialog .van-dialog__confirm {
  color: #fff;
  background: linear-gradient(135deg, #7c6ff0, #db6ea9);
  box-shadow: 0 9px 22px rgba(124, 111, 240, 0.28);
}

.recharge-contact-dialog .van-dialog__confirm::before {
  content: "☎";
  margin-right: 8px;
  font-size: 28px;
}

.recharge-contact-dialog [class*="van-hairline"]::after {
  border: 0;
}
</style>
